import React from 'react';

import { SHOTS } from '../lib/art';

/**
 * A real app screenshot in a minimal device frame.
 *
 * Screenshots are captured from the shipped app on the iOS Simulator and
 * carry their own status bar and Dynamic Island, so the frame is just a
 * bezel and a shadow — no fake notch to double up.
 */
export function PhoneShot({ name, caption, tilt = true }) {
  const spec = SHOTS[name];

  if (!spec) {
    if (process.env.NODE_ENV !== 'production') {
      throw new Error(`PhoneShot: unknown screenshot "${name}"`);
    }
    return null;
  }

  return (
    <figure style={{ margin: 0 }}>
      <div className={`shot${tilt ? ' shot--tilt' : ''}`}>
        <img
          src={spec.src}
          alt={spec.alt}
          loading="lazy"
          decoding="async"
          width="820"
          height="1783"
        />
      </div>
      {caption ? (
        <figcaption className="shot-caption">{caption}</figcaption>
      ) : null}
    </figure>
  );
}

export default PhoneShot;
